/**
 * e.g. "2026-04-01" → "1 April 2026"
 */
export function formatLongDate(iso) {
  if (!iso) return '';
  const part = String(iso).split('T')[0];
  const [y, m, d] = part.split('-').map(Number);
  if (!y || !m || !d) return String(iso);
  const dt = new Date(y, m - 1, d, 12, 0, 0);
  return dt.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}
